import { AnimatePresence, motion } from 'motion/react';
import '../styles/MobileMenu.css';

const MENU_ITEMS = [
  {
    label: 'XDP Airdrop',
    href: 'https://app.doppler.finance/airdrop',
    icon: (<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" /><circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.6" /></svg>),
  },
  {
    label: 'Doppler Vaults',
    href: 'https://app.doppler.finance/vaults',
    icon: (<svg viewBox="0 0 24 24" fill="none"><path d="M12 2l9 5v10l-9 5-9-5V7l9-5z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" /></svg>),
  },
  {
    label: 'Lending',
    comingSoon: true,
    icon: (<svg viewBox="0 0 24 24" fill="none"><rect x="5" y="11" width="14" height="9" rx="2" stroke="currentColor" strokeWidth="1.6" /><path d="M8 11V8a4 4 0 0 1 8 0v3" stroke="currentColor" strokeWidth="1.6" /></svg>),
  },
  {
    label: 'Institutional Vault',
    href: '#institutions',
    icon: (<svg viewBox="0 0 24 24" fill="none"><path d="M3 10l9-6 9 6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" /><path d="M5 10v9h14v-9" stroke="currentColor" strokeWidth="1.6" /><path d="M9 19v-6h6v6" stroke="currentColor" strokeWidth="1.6" /></svg>),
  },
  {
    label: 'Yield-as-a-service',
    href: '#products',
    icon: (<svg viewBox="0 0 24 24" fill="none"><path d="M12 2l2.5 6.5L21 11l-6.5 2.5L12 20l-2.5-6.5L3 11l6.5-2.5L12 2z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" /></svg>),
  },
  {
    label: 'Docs',
    href: 'https://docs.doppler.finance/',
    icon: (<svg viewBox="0 0 24 24" fill="none"><path d="M7 3h7l4 4v14H7z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" /><path d="M14 3v4h4" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" /></svg>),
  },
  {
    label: 'Blog',
    href: 'https://blog.doppler.finance/',
    icon: (<svg viewBox="0 0 24 24" fill="none"><path d="M4 11a9 9 0 0 1 9 9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /><path d="M4 4a16 16 0 0 1 16 16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /><circle cx="5" cy="19" r="1.5" fill="currentColor" /></svg>),
  },
];

const SOCIALS = [
  { label: 'X', href: 'https://x.com/doppler_fi', icon: (<svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.53 3H21l-7.5 8.57L22 21h-6.9l-5.4-6.6L3.9 21H.4l8.03-9.18L1 3h7.06l4.9 6.02L17.53 3z"/></svg>) },
  { label: 'Discord', href: 'https://discord.com/invite/hvDrh3WXhr', icon: (<svg viewBox="0 0 24 24" fill="currentColor"><path d="M20.3 4.7A19 19 0 0 0 15.7 3l-.3.6a13 13 0 0 1 4 1.7 15 15 0 0 0-14.8 0A13 13 0 0 1 8.6 3.6L8.3 3A19 19 0 0 0 3.7 4.7C1 8.8.3 12.8.6 16.8a19 19 0 0 0 5.7 2.9l1-1.6a12 12 0 0 1-1.9-.9l.4-.4a13.6 13.6 0 0 0 11.4 0l.4.4a12 12 0 0 1-1.9.9l1 1.6a19 19 0 0 0 5.7-2.9c.4-4.6-.7-8.6-2.5-12.1zM9 13.9c-.9 0-1.6-.8-1.6-1.9s.7-1.9 1.6-1.9 1.7.9 1.6 1.9c0 1.1-.7 1.9-1.6 1.9zm6 0c-.9 0-1.6-.8-1.6-1.9s.7-1.9 1.6-1.9 1.7.9 1.6 1.9c0 1.1-.7 1.9-1.6 1.9z"/></svg>) },
  { label: 'Telegram', href: 'https://t.me/doppler_finance', icon: (<svg viewBox="0 0 24 24" fill="currentColor"><path d="M21.9 3.5L2.6 11c-1 .4-1 1.7.1 2l4.8 1.5 1.9 5.9c.3.8 1.3 1 1.9.4l2.6-2.6 4.7 3.5c.8.6 2 .2 2.2-.8l3-16.1c.3-1.2-.9-2.2-2-1.8zM8.8 14l9.2-7.6-10.7 8.4-.3 3.1L8.8 14z"/></svg>) },
];

export default function MobileMenu({ isOpen, onClose }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            className="mobile-menu-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />
          <motion.div
            className="mobile-menu"
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
            role="dialog"
            aria-modal="true"
            aria-label="Doppler Finance menu"
          >
            <div className="mobile-menu__header">
              <span>Doppler Finance</span>
              <button type="button" aria-label="Close menu" onClick={onClose}>×</button>
            </div>

            <nav className="mobile-menu__list">
              {MENU_ITEMS.map((item) =>
                item.comingSoon ? (
                  <span key={item.label} className="mobile-menu__item mobile-menu__item--disabled">
                    <span className="mobile-menu__icon">{item.icon}</span>
                    {item.label} <span className="mobile-menu__soon">(Coming soon)</span>
                  </span>
                ) : (
                  <a
                    key={item.label}
                    href={item.href}
                    target={item.href.startsWith('http') ? '_blank' : undefined}
                    rel="noreferrer"
                    className="mobile-menu__item"
                    onClick={onClose}
                  >
                    <span className="mobile-menu__icon">{item.icon}</span>
                    {item.label}
                    <span className="mobile-menu__arrow">↗</span>
                  </a>
                )
              )}
            </nav>

            <div className="mobile-menu__socials">
              {SOCIALS.map((s) => (
                <a key={s.label} href={s.href} target="_blank" rel="noreferrer" aria-label={s.label} className="mobile-menu__social">
                  {s.icon}
                </a>
              ))}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}